import { ColorPreview } from './styled'

export const colorOptions = [
  {
    value: '#34CB9E',
    label: <ColorPreview color='#34CB9E' />
  },
  {
    value: '#78C3FB',
    label: <ColorPreview color='#78C3FB' />
  },
  {
    value: '#FB8F67',
    label: <ColorPreview color='#FB8F67' />
  },
  {
    value: '#F96990',
    label: <ColorPreview color='#F96990' />
  },
  {
    value: '#fffc37',
    label: <ColorPreview color='#fffc37' />
  },
  {
    value: '#771ab6',
    label: <ColorPreview color='#771ab6' />
  }
]
